import { INITIAL_USER_PRINT } from '@app/constants';
import type { NAuth } from '@app/types/Auth';

export const AUTH_INITIAL_STATE: NAuth.AuthInitialState = {
  user: {
    ...INITIAL_USER_PRINT,
    nameFirst: '',
    nameLast: '',
    email: '',
    phone: '',
    gender: null,
    photo: '',
    dateBirth: '',
    isAdmin: false,
    accessCode: '',
    position: '',
    telCode: '',
  },
  accessRights: null,
  activeBranchName: null,
  activeBranchCountryId: null,
  organizations: [],
};
